import { SAVE_AUTH_INFO } from "features/yard360/store/authInfo/types";

export const INITIAL_AUTH_INFO = {
  securityToken: null,
  realm: null,
  domain: null,
  activeBuildingCode: null,
  selectedBuildingCode: null,
  mapApiKeys: null,
};

export const authInfoReducer = (state = INITIAL_AUTH_INFO, action) => {
  switch (action.type) {
    case SAVE_AUTH_INFO:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
